import { Spin, message } from 'antd'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { LoadingOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom'
import { SocketInstance } from '../Services/socket/socket.client';

const LoaderLayout = ({ children }) => {

    let User = JSON.parse(localStorage.getItem('user_profile'))
    const history = useHistory()

    useEffect(() => {
        localStorage.setItem('last_route', window.location.pathname)
        SocketInstance.on(`employee-alert`, (payload) => {
            const { currentDateTime, user_id, mobile } = payload;
            if (!User) return
            if (mobile) return;
            if (User?.EmployeeStatusId != 9) return
            if (User?.id != user_id) return
            User = JSON.parse(localStorage.getItem('user_profile'))
            if (currentDateTime == User?.currentDateTime) return
            message.destroy()
            message.error("Your account has been logged in on another device")
            localStorage.removeItem('access_jwt')
            history.push('/login/140040')
            SocketInstance.off()
        })
    }, [])

    const { main } = useSelector(state => state.utils.pageLoader)

    return (
        <Spin
            style={{ height: "100vh", position: "fixed", inset: 0, zIndex: 100000000000000 }}
            spinning={main || false}
            indicator={<LoadingOutlined
                style={{
                    fontSize: 24,
                }}
                spin
            />}>
            {children}
        </Spin>
    )
}

export default LoaderLayout